export default "__VITE_ASSET__bVQVRSmK__"